/* eslint-disable */
import cookiePolicyDomain from './cookie-policy.domain.js';

export const domain = cookiePolicyDomain;
